"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutoResizer = void 0;
var react_1 = require("react");
var useSDK_1 = require("./useSDK");
/**
 * Starts/stops the auto resizer when the component is mounted/unmounted.
 * Must be wrapped by SDKProvider.
 * Can only be used when app is rendered in field, sidebar or dialog locations.
 * @param {Object} params - Options to be passed to auto resizer
 * @param {Boolean} params.absoluteElements - Defines if auto resizer should consider absolute elements
 */
function useAutoResizer() {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        params[_i] = arguments[_i];
    }
    var sdk = (0, useSDK_1.useSDK)();
    (0, react_1.useEffect)(function () {
        var _a;
        if (typeof sdk.window === 'undefined') {
            throw new Error('useAutoResizer is unavailable at this location, it can only be rendered in field, sidebar and dialog locations.');
        }
        (_a = sdk.window).startAutoResizer.apply(_a, params);
        return sdk.window.stopAutoResizer;
    }, [sdk.window]);
}
exports.useAutoResizer = useAutoResizer;
